<template>
  <StatusBadgeWithTooltip
    :status="status"
    :statusText="text"
    :tooltipText="tooltipText"
  />
</template>

<script>
// Utils
import { get } from 'lodash';

// Components
import StatusBadgeWithTooltip from 'client/components/Badges/StatusBadgeWithTooltip.vue';

// Constants
import { ItemTypeRoutes } from 'client/util/Constants';

export default {
  name: 'SystemUserMFARequirementBadgeWithTooltip',

  components: {
    StatusBadgeWithTooltip,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isMFARequired() {
      const statusPath = 'enable_user_portal_multifactor';
      return get(this.item, statusPath, false);
    },

    status() {
      return this.isMFARequired ? 'success' : 'inactive';
    },

    text() {
      return this.isMFARequired ? 'Required' : 'Not Required';
    },

    tooltipText() {
      const username = get(this.item, 'username', '');
      const prependage = username ? `This user **${username}**` : 'This user';
      const verb = this.isMFARequired ? 'is' : "isn't";
      const appendage = `required to authenticate with MFA to the User Portal. This may be overridden by [Conditional Access Policies](${window.location.origin}/${ItemTypeRoutes.authNPolicies}).`;

      return `${prependage} ${verb} ${appendage}`;
    },
  },
};
</script>
